export const messages = {
  en: {
    newContractManage: {
      search: {
        title: 'Search Conditions',
        contractNamePlaceholder: 'Please enter contract name',
        contractCodePlaceholder: 'Please enter contract code',
        contractTypePlaceholder: 'Please select contract type'
      },
      list: {
        title: 'Draft Contract Information',
        draft: 'Draft',
        note: 'Note: Please go to System Management > Process Management to set up contract application renewal before using this function'
      },
      table: {
        contractName: 'Contract Name',
        contractCode: 'Contract Code',
        parentContractCode: 'Parent Contract Code',
        contractType: 'Contract Type',
        operator: 'Operator',
        amount: 'Contract Amount',
        startTime: 'Start Time',
        endTime: 'End Time',
        state: 'Status'
      },
      edit: {
        title: 'Edit Contract',
        contractName: 'Contract Name',
        contractNamePlaceholder: 'Required, please fill in contract name',
        contractCode: 'Contract Code',
        contractCodePlaceholder: 'Required, please fill in contract code',
        contractType: 'Contract Type',
        contractTypePlaceholder: 'Required, please select contract type',
        partyA: 'Party A',
        partyAPlaceholder: 'Required, please fill in Party A',
        partyB: 'Party B',
        partyBPlaceholder: 'Required, please fill in Party B',
        aContacts: 'Party A Contact',
        aContactsPlaceholder: 'Required, please fill in Party A contact',
        bContacts: 'Party B Contact',
        bContactsPlaceholder: 'Required, please fill in Party B contact',
        aLink: 'Party A Phone',
        aLinkPlaceholder: 'Required, please fill in Party A phone',
        bLink: 'Party B Phone',
        bLinkPlaceholder: 'Required, please fill in Party B phone',
        operator: 'Operator',
        operatorPlaceholder: 'Required, please fill in operator',
        operatorLink: 'Operator Phone',
        operatorLinkPlaceholder: 'Required, please fill in operator phone',
        amount: 'Contract Amount',
        amountPlaceholder: 'Optional, please fill in contract amount',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please fill in start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please fill in end time',
        signingTime: 'Signing Time',
        signingTimePlaceholder: 'Required, please fill in signing time',
        contractFile: 'Contract Attachment',
        addFile: 'Add Attachment',
        upload: 'Upload',
        deleteFile: 'Delete',
        fileIndex: 'No.{index}'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete the contract information?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      validate: {
        contractNameRequired: 'Contract name cannot be empty',
        contractNameMaxLength: 'Contract name cannot exceed 200 characters',
        contractCodeRequired: 'Contract code cannot be empty',
        contractCodeMaxLength: 'Contract code cannot exceed 30 characters',
        contractTypeRequired: 'Contract type cannot be empty',
        partyARequired: 'Party A cannot be empty',
        partyAMaxLength: 'Party A name is too long',
        partyBRequired: 'Party B cannot be empty',
        partyBMaxLength: 'Party B name is too long',
        aContactsRequired: 'Party A contact cannot be empty',
        aContactsMaxLength: 'Party A contact length exceeds 64 characters',
        bContactsRequired: 'Party B contact cannot be empty',
        bContactsMaxLength: 'Party B contact length exceeds 64 characters',
        aLinkRequired: 'Party A phone cannot be empty',
        bLinkRequired: 'Party B phone cannot be empty',
        operatorRequired: 'Operator cannot be empty',
        operatorMaxLength: 'Operator exceeds 64 characters',
        operatorLinkRequired: 'Operator phone cannot be empty',
        amountFormat: 'Contract amount format error, such as 1.50',
        startTimeRequired: 'Start time cannot be empty',
        endTimeRequired: 'End time cannot be empty',
        signingTimeRequired: 'Signing time cannot be empty',
        fileTypeError: 'Operation failed, please upload image or PDF format file'
      },
      uploadSuccess: 'Upload successfully',
      uploadError: 'Upload failed',
      updateSuccess: 'Update successfully',
      updateError: 'Update failed',
      fetchError: 'Failed to fetch contract data',
      page: {
        subtitle: 'Manage draft contracts and related operations',
        empty: 'No draft contracts found',
        loadFailed: 'Failed to fetch contract data'
      }
    }
  },
  zh: {
    newContractManage: {
      search: {
        title: '查询条件',
        contractNamePlaceholder: '请输入合同名称',
        contractCodePlaceholder: '请输入合同编号',
        contractTypePlaceholder: '请选择合同类型'
      },
      list: {
        title: '起草合同信息',
        draft: '起草',
        note: '注意：此功能使用前请先到系统管理>流程管理中设置合同申请续签'
      },
      table: {
        contractName: '合同名称',
        contractCode: '合同编号',
        parentContractCode: '父合同编号',
        contractType: '合同类型',
        operator: '经办人',
        amount: '合同金额',
        startTime: '开始时间',
        endTime: '结束时间',
        state: '状态'
      },
      edit: {
        title: '编辑合同',
        contractName: '合同名称',
        contractNamePlaceholder: '必填，请填写合同名称',
        contractCode: '合同编号',
        contractCodePlaceholder: '必填，请填写合同编号',
        contractType: '合同类型',
        contractTypePlaceholder: '必填，请选择合同类型',
        partyA: '甲方',
        partyAPlaceholder: '必填，请填写甲方',
        partyB: '乙方',
        partyBPlaceholder: '必填，请填写乙方',
        aContacts: '甲方联系人',
        aContactsPlaceholder: '必填，请填写甲方联系人',
        bContacts: '乙方联系人',
        bContactsPlaceholder: '必填，请填写乙方联系人',
        aLink: '甲方联系电话',
        aLinkPlaceholder: '必填，请填写甲方联系电话',
        bLink: '乙方联系电话',
        bLinkPlaceholder: '必填，请填写乙方联系电话',
        operator: '经办人',
        operatorPlaceholder: '必填，请填写经办人',
        operatorLink: '联系电话',
        operatorLinkPlaceholder: '必填，请填写联系电话',
        amount: '合同金额',
        amountPlaceholder: '选填，请填写合同金额',
        startTime: '开始时间',
        startTimePlaceholder: '必填，请填写开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        signingTime: '签订时间',
        signingTimePlaceholder: '必填，请填写签订时间',
        contractFile: '合同附件',
        addFile: '添加附件',
        upload: '上传',
        deleteFile: '删除',
        fileIndex: '第{index}个'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除合同信息',
        success: '删除成功',
        error: '删除失败'
      },
      validate: {
        contractNameRequired: '合同名称不能为空',
        contractNameMaxLength: '合同名称不能超过200位',
        contractCodeRequired: '合同编号不能为空',
        contractCodeMaxLength: '合同编号错误',
        contractTypeRequired: '合同类型不能为空',
        partyARequired: '甲方不能为空',
        partyAMaxLength: '甲方名称太长',
        partyBRequired: '乙方不能为空',
        partyBMaxLength: '乙方名称太长',
        aContactsRequired: '甲方联系人不能为空',
        aContactsMaxLength: '甲方联系人长度超过64位',
        bContactsRequired: '乙方联系人不能为空',
        bContactsMaxLength: '乙方联系人长度超过64位',
        aLinkRequired: '甲方联系电话不能为空',
        bLinkRequired: '乙方联系电话不能为空',
        operatorRequired: '经办人不能为空',
        operatorMaxLength: '经办人超过64位',
        operatorLinkRequired: '联系电话不能为空',
        amountFormat: '合同金额格式错误，如1.50',
        startTimeRequired: '开始时间不能为空',
        endTimeRequired: '结束时间不能为空',
        signingTimeRequired: '签订时间不能为空',
        fileTypeError: '操作失败，请上传图片、PDF格式的文件'
      },
      uploadSuccess: '上传成功',
      uploadError: '上传失败',
      updateSuccess: '修改成功',
      updateError: '修改失败',
      fetchError: '获取合同数据失败',
      page: {
        subtitle: '管理起草合同与相关操作',
        empty: '暂无起草合同',
        loadFailed: '获取合同数据失败'
      }
    }
  }
}